import axiosInstance from "../utils/axios";

const BASE_URL = "api/TenantUserPreferences";

/**
 * Fetch saved user preference for a given page and type
 * @param {string} pageKey - Unique key identifying the page (e.g. "schedule_list")
 * @param {string} [typeKey="QuickFilter"] - Preference type key
 * @returns {Promise<any>} Deserialized preference value or null
 */
export const getUserPreference = async (pageKey, typeKey = "QuickFilter") => {
  try {
    const response = await axiosInstance.get(BASE_URL, {
      params: { pageKey, typeKey },
    });
    const rawData = response?.data?.data;
    if (!rawData) return null;
    if (typeof rawData === "string") {
      try {
        return JSON.parse(rawData);
      } catch (e) {
        return rawData;
      }
    }
    return rawData;
  } catch (error) {
    console.error("Error fetching user preference:", error);
    return null;
  }
};

/**
 * Save user preference for a given page and type
 * @param {string} pageKey - Unique key identifying the page
 * @param {any} preferenceValue - The preference state to save
 * @param {string} [typeKey="QuickFilter"] - Preference type key
 * @returns {Promise<any>}
 */
export const saveUserPreference = async (pageKey, preferenceValue, typeKey = "QuickFilter") => {
  try {
    const response = await axiosInstance.post(BASE_URL, {
      pageKey,
      typeKey,
      preferenceValue,
    });
    return response?.data;
  } catch (error) {
    console.error("Error saving user preference:", error);
    throw error;
  }
};
